import { Box, Button, Stack} from '@mui/material';
import { Typography,List, ListItem } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate();

  return (
    <Stack spacing={0} >
        <Typography variant='h6' component='h6' textAlign='center'>
        This online tool will help you cut down methane emissions from your slurry.
        </Typography>
 <Box textAlign="center">
  <Typography variant="body2" component="h2" gutterBottom>
    It estimates how much methane your slurry releases each day by using two simple facts:
  </Typography>
  <Box display="inline-block" textAlign="left" mb={1}>
    <List dense>
      <ListItem>Warmer slurry gives off more methane.</ListItem>
      <ListItem>More slurry means more emissions.</ListItem>
    </List>
  </Box>

  <Typography variant="body2" gutterBottom>
    <strong>To find dates to empty your slurry</strong> that reduce slurry methane emissions it uses the following information from your farm:
  </Typography>
  <Box display="inline-block" textAlign="left" mb={1}>
    <List dense>
      <ListItem>The local weather forecast.</ListItem>
      <ListItem>When you house your cattle.</ListItem>
      <ListItem>When you might empty your slurry.</ListItem>
    </List>
  </Box>

  <Typography variant="body2" gutterBottom>
    Based on the results, it helps you choose dates to empty your slurry to keep emissions low.
  </Typography>

  <Typography variant="body2" gutterBottom>
    Press "Start" to begin lowering your slurry methane emissions.
  </Typography>
</Box>
        <Box display='flex' justifyContent='center'>
          <Button color='primary' variant='outlined' size='large' onClick={() => navigate('/inputs')}>
            Start
          </Button>
        </Box>
        <Box mt={2} display="flex" justifyContent="center">
          <Typography variant="body1" textAlign='center' component="div" style={{ fontSize: 10, whiteSpace: 'normal' }}>
          Funded and supported by the UKRI Agri-Food for Net Zero Network+ (Grant number: EP/X011062/1)
          and Rural and Environment Science and Analytical Services Division (SRUC-C5-1). 
          Weather data by <a href="https://open-meteo.com/">Open-Meteo.com</a> licensed under <a href="https://creativecommons.org/licenses/by/4.0/">Creative Commons Attribution 4.0 International (CC BY 4.0)</a>.<br/>
          Feedback is welcome and should be emailed to dfletcher(at)sruc(dot)ac(dot)uk.
          </Typography>
        </Box>
    </Stack>       
       
  );
}

export default Home;
